export class Masks {
  private static onlyAlphanumeric(value: string): string {
    if (!value) return "";

    return value.replace(/[^a-z0-9]/gi, "");
  }

  private static onlyLetters(value: string): string {
    if (!value) return "";

    return value.replace(/[^a-zÀ-ú ]/gi, "");
  }

  static onlyNumbers(value: string): string {
    if (!value) return "";

    return value.replace(/[^0-9 ]/gi, "");
  }

  static onlyNumbersAndDots(value: string): string {
    if (!value) return "";

    return value.replace(/[^0-9.,]/gi, "");
  }

  private static maxLength(value: string, max: number): string {
    if (!value) return "";

    return value.substring(0, max);
  }

  static socialNumberMask(value: string): string {
    if (!value) return "";

    value = value.replace(/\D/g, "");
    value = this.maxLength(value, 11);
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return value;
  }

  static crmMask(value: string): string {
    if (!value) return "";

    value = this.onlyAlphanumeric(value);
    value = this.maxLength(value, 15);
    return value;
  }

  static unknowTelephoneNumberMask(value: string): string {
    if (!value) return "";

    value = value.replace(/\D/g, "");
    if (value.length === 10) return this.telephoneMask(value);
    else if (value.length === 11) return this.cellphoneMask(value);
    return value;
  }

  static telephoneMask(value: string): string {
    if (!value) return "";

    value = value.replace(/\D/g, "");
    value = this.maxLength(value, 10);
    value = value.replace(/(\d{2})(\d)/, "($1) $2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
    return value;
  }

  static cellphoneMask(value: string): string {
    if (!value) return "";

    value = value.replace(/\D/g, "");
    value = this.maxLength(value, 11);
    value = value.replace(/(\d{2})(\d)/, "($1) $2");
    value = value.replace(/(\d{5})(\d)/, "$1-$2");
    return value;
  }

  static nameMask(value: string): string {
    if (!value) return "";

    value = this.onlyLetters(value);
    value = this.maxLength(value, 100);
    return value;
  }

  static emailMask(value: string): string {
    if (!value) return "";

    value = this.maxLength(value, 50);
    return value;
  }

  static fiscalNumberMask(value: string): string {
    if (!value) return "";

    value = value.trim().toUpperCase();
    const cleaned = value.replace(/[.\/-]/g, "");
    const length = cleaned.length;

    if (/[A-Z]/.test(cleaned)) {
      if (length <= 2) return cleaned;
      if (length <= 5) return cleaned.replace(/^(.{2})(.*)/, "$1.$2");
      if (length <= 8) return cleaned.replace(/^(.{2})(.{3})(.*)/, "$1.$2.$3");
      if (length <= 12) return cleaned.replace(/^(.{2})(.{3})(.{3})(.*)/, "$1.$2.$3/$4");
      return cleaned.slice(0, 14).replace(/^(.{2})(.{3})(.{3})(.{4})(.*)/, "$1.$2.$3/$4-$5");
    }

    switch (length) {
      case 0:
      case 1:
      case 2:
        return cleaned;
      case 3:
        return cleaned.replace(/^(\d{2})(\d{1})/, "$1.$2");
      case 4:
        return cleaned.replace(/^(\d{2})(\d{2})/, "$1.$2");
      case 5:
        return cleaned.replace(/^(\d{2})(\d{3})/, "$1.$2");
      case 6:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{1})/, "$1.$2.$3");
      case 7:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{2})/, "$1.$2.$3");
      case 8:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})/, "$1.$2.$3");
      case 9:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{1})/, "$1.$2.$3/$4");
      case 10:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3/$4");
      case 11:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{3})/, "$1.$2.$3/$4");
      case 12:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})/, "$1.$2.$3/$4");
      case 13:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1})/, "$1.$2.$3/$4-$5");
      case 14:
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
      default:
        return cleaned.slice(0, 14).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
  }

  static codeMask(value: string): string {
    if (!value) return "";

    value = this.maxLength(value, 6);
    value = this.onlyNumbers(value);
    return value;
  }

  static hoursMask(value: string): string {
    if (!value) return "";

    value = value.replace(/\D/g, "");
    value = this.maxLength(value, 4);
    value = value.replace(/(\d{2})(\d)/, "$1:$2");
    return value;
  }

  static dateMask(value: string): string {
    if (!value) return "";

    value = value.replace(/\D/g, "");
    value = this.maxLength(value, 8);
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{4})/, "$1");
    return value;
  }

  static cardNumberMask(value: string): string {
    if (!value) return "";

    value = value.replace(/\D/g, "");
    value = this.maxLength(value, 17);
    value = value.replace(/(\d{4})(\d)/, "$1 $2");
    value = value.replace(/(\d{4})(\d)/, "$1 $2");
    value = value.replace(/(\d{4})(\d)/, "$1 $2");
    return value;
  }
}
